import React, {
    useEffect,
    useState,
} from 'react';

import { classesAPI } from 'api/classesAPI';
import { coachingAPI } from 'api/coachingAPI';
import SearchIcon from 'assets/images/icon/SearchIcon';
import { cloneDeep } from 'lodash';
import { useNavigate } from 'react-router-dom';
import ReactSlider from 'react-slider';
import { useRecoilValue } from 'recoil';
import {RequestedData, userInfo} from 'state';
import styled, {keyframes} from 'styled-components';
import { isEmpty } from 'util/isEmpty';
import {
    DropdownMenu,
    Overlay,
    Pagenation,
} from 'view/components';
import { CheckBox } from 'view/components/common/CheckBox';
import CreatePopup from 'view/pages/Coaching/components/CreatePopup';
import RequestPopup from 'view/pages/Coaching/components/RequestPopup';
import ListItem from "../components/ListItem";
import {liveAPI} from "../../../../api/liveAPI";
import CompletedPopup from "../components/CompletedPopup";
import CompletedListItem from "../components/CompletedListItem";
import SmallCalendar from "../../../components/common/SmallCalendar";
import dayjs from "dayjs";
import EmptyBox from "../../../components/common/EmptyBox";
import SearchInputItem from "../../../components/common/SearchInputItem";

const rangeArr = ["Today","This week","This month","All time"];
const fadeIn = keyframes`
    0% {
        opacity: 0;
        transform: translateY(-10px) scale(0.8);
    }
    50% {
        opacity: 0; /* 중간 상태에서 조금 투명하게 */
    }
    60% {
        opacity: 0; /* 중간 상태에서 조금 투명하게 */
    }
    100% {
        transform: scale(0.8);
        opacity: 1;
    }
`;
const Completed = (props) => {
    const navigate = useNavigate();
    const [popup, setPopup] = useState(false);
    const reqData = useRecoilValue(RequestedData)
    const [list, setList] = useState([]);
    const [classList, setClassList] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [coachingTitle, setCoachingTitle] = useState("")
    const [selectClass, setSelectClass] = useState(null);
    const [completedPopup, setCompletedPopup] = useState(false);
    const [completed, setCompleted] = useState(true);
    const [received, setRceived] = useState(true);
    const [indexValue, setIndexValue] = useState({
        i: 0,
        v: 5,
    });
    const [pageInfo, setPageInfo] = useState({
        totalPages: 0,
        number: 0,
        size: 5,
    });
    const user = useRecoilValue(userInfo);
    const getReqList = () => {
        liveAPI.getRequestData({
            params:{
                coachingStatus:"COMPLETED",
                size:100
            }
        })
            .then(res => {
                console.log("@res",res);
                setList(cloneDeep(res?.data?.content))
            })
    };
    // const getCoachingList = async () => {
    //     const result = await coachingAPI
    //         .getCoachingRequest({
    //             params: {
    //                 isNew:true,
    //                 // isReceived: received === true && completed === true ? "" : received,
    //                 // isCompleted: received === true && completed === true ? "" : !received,
    //                 // paged: true,
    //                 // page: pageNumber,
    //                 size: 105,
    //                 // gradeFrom:0,
    //                 // gradeTo:indexValue.v
    //             },
    //         })
    //         .then((res) => {
    //             console.log("coa data", res?.content);
    //             setList(cloneDeep(res?.content));
    //             // setPageInfo({
    //             //     totalPages: res?.totalPages,
    //             //     number: res?.number,
    //             //     size: res?.size,
    //             // });
    //         });
    // };
    const [tab, setTab] = useState("Upcomming")
    const getCoachingList = async (allTime = false) => {
        liveAPI.getRequestData({
            params:{
                coachingStatus:"COMPLETED"
            }
        })
            .then(res => {
                const c = cloneDeep(res?.data?.content)
                console.log("@res",res);
                const sortData = c?.sort((a, b) => {
                    const dateComparison = a.coachingApplication.liveCoaching.liveCoachingSlot.localDate.localeCompare(b.coachingApplication.liveCoaching.liveCoachingSlot.localDate);
                    if (dateComparison !== 0) {
                        return dateComparison;
                    }
                    return a.coachingApplication.liveCoaching.liveCoachingSlot.startTime.localeCompare(b.coachingApplication.liveCoaching.liveCoachingSlot.startTime);
                });

                const s = new Date(dayjs(new Date).format("YYYY-MM-DD 00:00:00")).getTime()
                const filteredData = sortData.filter(item => {
                    const currentDate = new Date(item.coachingApplication.liveCoaching.liveCoachingSlot.localDate).getTime();
                    console.log("@currentDate",currentDate);
                    return tab == "Upcomming" ? s <= currentDate : s >= currentDate;
                });
                if(allTime){
                    setList(cloneDeep(filteredData))
                }else{
                    getRange(cloneDeep(filteredData));
                }
            })
    };

    const getRange = (list) => {
        const c = cloneDeep(list)
        const startDate = dayjs(popupDate).format("YYYY-MM-DD 00:00:00");
        const endDate = dayjs(endPopupDate).format("YYYY-MM-DD 11:59:59");
        const s = new Date(startDate).getTime();
        const e = new Date(endDate).getTime();
        // 날짜 범위에 해당하는 데이터 필터링
        const filteredData = c.filter(item => {
            const currentDate = new Date(item.coachingApplication.liveCoaching.liveCoachingSlot.localDate).getTime();
            console.log("@currentDate",currentDate);
            // @ts-ignore
            return s <= currentDate && e >= currentDate
        });
        setList(cloneDeep(filteredData))
        console.log("@filteredData",filteredData, s, e);
    };

    const getClassItems = () => {
        const c = cloneDeep(classList);
        const arr = c
            ?.map((item) => {
                return {
                    ...item,
                    dropdownItem: item?.classTitle || "",
                };
            })
            .filter((filterItem) => {
                return filterItem?.progress === "PUBLISHED";
            });
        return arr || [];
    };

    const onClickDropdown = (item: any, key: string, index, obj) => {
        let selectItem;
        console.log("obj", obj);
        if (!isEmpty(obj)) {
            const copy = cloneDeep(obj);
            delete copy.dropdownItem;
            selectItem = copy;
        } else {
            selectItem = item;
        }
        console.log("selectItem", selectItem);
        setSelectClass(cloneDeep(selectItem));
    };

    const createCoaching = async () => {
        coachingAPI.createCoaching({
            params:{
                classesId:selectClass?.id,
                title:coachingTitle
            }
        })
            .then(res => {
                if(res?.success === true && !isEmpty(res?.data?.id)){
                    navigate("/create_coaching/details",{
                        state:{
                            createId:res?.data?.id
                        }
                    })
                }
            })
    };

    console.log('selectClass', selectClass)

    const onClickGetData = (item) => {
        setSelectedData(cloneDeep(item));
        setCompletedPopup(true)
    };

    const onClickMovePage = (isNext) => {
        const c = cloneDeep(pageInfo);
        if (isNext) {
            if (pageInfo?.number + 1 === pageInfo?.totalPages) return;
            c.number = c.number + 1;
        } else {
            if (pageInfo?.number === 0) return;
            c.number = c.number - 1;
        }
        setPageInfo(c);
    };

    // useEffect(() => {
    //     getCoachingList();
    // }, []);

    // useEffect(() => {
    //     getCoachingList(pageInfo?.number);
    // }, [pageInfo.number]);

    // useEffect(() => {
    //     getCoachingList(0);
    // }, [indexValue?.v]);

    // useEffect(() => {
    //     getCoachingList(0);
    // }, [selectClass?.id]);

    // useEffect(() => {
    //     getClassItem();
    // }, []);
    const onClickPopupDate = (date) => {
        setPopupDate(date)
    };
    const onClickEndPopupDate = (date) => {
        setEndPopupDate(date)
    };

    const sortByUpdateDatetime = (a, b) => {
        const dateA = new Date(a.coachingApplication.updatedDatetime);
        const dateB = new Date(b.coachingApplication.updatedDatetime);
        // @ts-ignore
        return dateB - dateA; // 최신일수록 더 큰 값이 됨
    };
    const [datePopup, setDatePopup] = useState(false);
    const [range, setRange] = useState("All time");
    const [popupDate, setPopupDate] = useState(new Date());
    const [endPopupDate ,setEndPopupDate] = useState(new Date());
    const handleDateRangeButtonClick = (range) => {
        switch(range) {
            case 'This week':
                const thisWeekStart = dayjs().startOf('week').toDate();
                const thisWeekEnd = dayjs().endOf('week').toDate();
                setPopupDate(dayjs().startOf('day').toDate());
                setEndPopupDate(thisWeekEnd);
                break;
            case 'This month':
                const thisMonthStart = dayjs().startOf('month').toDate();
                const thisMonthEnd = dayjs().endOf('month').toDate();
                setPopupDate(dayjs().startOf('day').toDate()); // 현재 날짜의 시작 부분
                setEndPopupDate(thisMonthEnd);
                break;
            case 'Today':
                const today = new Date();
                setPopupDate(today);
                setEndPopupDate(today);
                break;
            case 'All time':{

                getCoachingList(true)
            }
                // All time에 해당하는 범위를 설정하십시오.
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        getReqList();
    }, []);

    useEffect(() => {
        if(range !== "All time"){
            getCoachingList(false);
        }

    },[popupDate,endPopupDate, range, tab]);
    console.log("list",list);
    console.log("@selectedData",selectedData);

    return (
        <Container>
            {popup && (
                <Overlay filter={true}>
                    <RequestPopup data={selectedData} onClickPopup={()=>{
                        getCoachingList();
                        setPopup(v => !v)
                    }} />
                </Overlay>
            )}
            {
                completedPopup && !isEmpty(selectedData) &&
                <Overlay filter={true}>
                    <CompletedPopup data={selectedData}
                                    scheduled={true}
                                    onClickGetList={()=>{
                                        getReqList();
                                    }}
                                    onClickPopup={()=>{
                                        setCompletedPopup(false)
                                    }} />
                </Overlay>
            }
            <ContentsInner>
                <h4>Date range</h4>
                <SearchArea style={{marginBottom: 15}}>
                    <DropDownArea style={{width: 260}}
                                  onClick={() => {
                                      setDatePopup(v => !v)
                                  }}
                                  className={`${datePopup ? "on" : ""}`}
                    >
                        <input type="text" readOnly={true}
                               value={`${dayjs(popupDate).format('DD MMM YYYY')} - ${dayjs(endPopupDate).format('DD MMM YYYY')}`}
                        />
                        <svg className={"arrow"} width="11" height="8" viewBox="0 0 11 8" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1.67969L5.5 6.17969L10 1.67969" stroke="#333333" strokeWidth={"2"}
                                  strokeLinecap={"round"} strokeLinejoin={"round"}/>
                        </svg>
                        {
                            datePopup &&
                            <PopupArea
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                            >
                                <PopupHeader>
                                    {
                                        rangeArr.map((item) => {
                                            return (
                                                <span
                                                    onClick={() => {
                                                        setRange(item);
                                                        handleDateRangeButtonClick(item);
                                                    }}
                                                    className={`${range === item ? "on" : ""} `}
                                                >{item}</span>
                                            )
                                        })
                                    }

                                </PopupHeader>
                                <CalArea>
                                    <SmallCalendar popupDate={popupDate} onClickPopupDate={(date) => {
                                        setRange("Custom")
                                        onClickPopupDate(date)
                                    }}>
                                    </SmallCalendar>
                                    <SmallCalendar popupDate={endPopupDate}
                                                   minDate={popupDate}
                                                   onClickPopupDate={(date) => {
                                                       setRange("Custom")
                                                       onClickEndPopupDate(date)
                                                   }}>
                                    </SmallCalendar>
                                </CalArea>
                                <CalBtn>
                                    <span
                                        onClick={() => {
                                            setDatePopup(false)
                                        }}
                                    >Cancel</span>
                                    <span
                                        onClick={() => {
                                            setDatePopup(false)
                                        }}
                                    >Apply</span>
                                </CalBtn>
                            </PopupArea>
                        }
                    </DropDownArea>
                    <SearchInputItem />

                </SearchArea>
                <Wrap
                    className={isEmpty(list) ? "empty" : ""}
                >
                    {
                        list?.sort(sortByUpdateDatetime)?.map((item, index) => {
                            return (<CompletedListItem
                                onClickGetData={onClickGetData}
                                data={item}></CompletedListItem>)
                        })
                    }
                    {
                        isEmpty(list) &&
                        <EmptyBox url={"/images/nothing.png"} />
                    }
                </Wrap>
            </ContentsInner>
            <Pagenation
                totalPage={pageInfo?.totalPages}
                onClickMove={(isNext) => {
                    onClickMovePage(isNext);
                }}
                size={pageInfo?.size}
                pageNumber={pageInfo?.number}
            />
        </Container>
    );
};
export default Completed;

const Container = styled.div`
    height: 100%;
    position: relative;
`;
const PopupArea = styled.div`
    animation: ${fadeIn} 0.3s ease-in-out; /* fadeIn keyframe을 사용하여 애니메이션 적용 */
    position: absolute;
    z-index: 99999;
    height: 530px;
    max-height: 530px;
    transform: scale(0.8);
    transform-origin: left top;
    left: 0;
    top: calc(100% + 15px);
    padding: 20px 10px;
    border-radius: 12px;
    transition: all 0.2s;
    cursor: pointer;

    h1 {
        display: none;
    }

    background: #fff;
    border: 1px solid rgba(51, 51, 51, 1);

    .calendarWrapper {
        margin: 0 10px;
        box-shadow: none;
        border: 0.4px solid rgba(51, 51, 51, 0.2);
        border-radius: 6px;
    }
`
const PopupHeader = styled.div`
    padding: 0 10px;
    margin-bottom: 20px;

    span {
        transition: color, border-bottom-color 0.2s;

        border-bottom: rgba(51, 51, 51, 0) solid 2px;
        cursor: pointer;
        margin-right: 20px;
        padding-bottom: 5px;
        font-family: Europa-Regular;
        font-size: 18px;
        font-weight: 700;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        color: rgba(51, 51, 51, 0.4);

        &.on {
            border-bottom: rgba(51, 51, 51, 1) solid 2px;
            font-family: Europa-Bold;
            font-size: 18px;
            font-weight: 700;
            line-height: 18px;
            letter-spacing: 0em;
            text-align: left;
            color: rgba(51, 51, 51, 1);
        }
    }
`
const CalArea = styled.div`
    display: flex;
`
const CalBtn = styled.div`
    position: absolute;
    left: 0;
    bottom: 15px;
    background: #fff;
    border-radius: 0 0 8px 8px;
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: center;

    span {
        margin: 0 10px;
        padding: 10px 0;
        justify-content: center;
        border-radius: 4px;
        display: flex;
        cursor: pointer;
        width: calc((50% - 20px) / 2);
        border: solid 1px #333;

        &:last-child {
            background: #333;
            color: #fff;
        }
    }
`
const ContentsInner = styled.div`
    padding: 20px;
    overflow: hidden;
    position: relative;
    height: calc(100vh - 250px);
    h4{
        font-family: Europa-Regular;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;

    }
`;
const Status = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const Wrap = styled.div`
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
    height: calc(100vh - 330px);
    overflow-y: auto;
    &.empty{
        &>div{
            width: 100%;
            height: 100%;
        }
    }

    .nothing {
        p {
            margin-top: 4%;
            width: 100%;
            text-align: center;
        }

        align-self: center;
        margin: 5% auto 5% auto;
        width: calc(331 / 1000 * 100%);
        height: calc(284 / 529 * 100%);

        img {
            width: 100%;
            height: 100%;
            max-height: 240px;
            object-fit: contain;
        }
    }

    &::-webkit-scrollbar {
        width: 0;
    }

    &::-webkit-scrollbar-thumb {
        width: 0;
        background-color: transparent;
    }
`;

const StatusCheck = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    p {
        margin-right: 15px;
        font-weight: 700;
        color: #333;
        font-size: 18px;
    }
`;
const SearchArea = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 30px;
    .addHeight{
        height: 44px!important;
    }
`;
const DropDownArea = styled.div`
    display: flex;
    width: 30%;
    cursor: pointer;
    position: relative;
    .arrow{
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
    }
    &.on{
        .arrow{
        }
    }
    height: 44px;
    border-radius: 8px;
    border: 1px;
    input{
        cursor: pointer;
        width: 100%;
        display: flex;
        border: 1px solid rgba(51, 51, 51, 0.3);
        border-radius: 8px;
        outline: none;
        padding: 12px 16px;

        font-family: Europa-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: left;

    }

`;

const DropDownWrap = styled.div`
    width: 100%;
    margin-right: 15px;
`;
const CheckItem = styled.div`
    span {
        margin-left: 5px;
        font-weight: 400;
        font-size: 18px;
    }
    margin-right: 15px;
    display: flex;
    align-items: center;
`;
const Slider = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    h5 {
        font-weight: 700;
        font-size: 18px;
        transform: translate(-20px, -7px);
    }
`;
const IndexItems = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 6px 0 6px;
    margin-top: 16px;
    span {
        text-align: center;
        display: flex;
        font-weight: 400;
        font-size: 14px;
        display: flex;
        justify-content: center;
    }
`;
const SliderWrap = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;

    .horizontal-slider {
        display: flex;
        align-items: center;

        .active {
            width: 16px;
            height: 16px;
            border: solid 1px red;
            background: red;
        }
        span {
            &:nth-child(1) {
                background: #fff;
            }
        }
        .mark {
            height: 16px;
            width: 16px;
            border-radius: 50%;
            background: #333;
            display: flex;
            align-items: center;
            justify-content: center;

            .indexItem {
                transform: translateY(10px);
            }
            &:first-of-type {
                background: #fff;
                border: solid 2px #333;
            }
            &:last-of-type {
                background: #fff;
                border: solid 2px #333;
            }
        }
        .track {
            height: 8px;
            border-radius: 6px;
            background: #3333331a;
        }
        .track-0 {
            background: #333333;
        }
        .thumb {
            border-radius: 50%;
            height: 16px;
            width: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #111;
        }
    }
`;
